module.exports = __webpack_public_path__ + "assets/img/t-tu.c5525386.png";